export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), //페이지 정보
	campaignList: [], //캠페인귀책목록
	campaignInfo: CAMPAIGN_INFO() //캠페인귀책 상세정보
};

function SEARCH_PARAMS() {
	return {
		cmpnNo: '' /*캠페인번호 */
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function CAMPAIGN_INFO() {
	return {
		cmpnNo: '', // 캠페인번호
		cmpnNm: '', // 캠페인명
		cpnyCd: '', // 귀책업체코드
		cpnyNm: '', // 귀책업체명
		atblRt1: '', // 귀책율(HTWO)
		atblRt2: '', // 귀책율(HMC)
		atblRt3: '', // 귀책율(협력사)
		atblRt4: '' // 귀책율(OEM)
	};
}

export { SEARCH_PARAMS, CAMPAIGN_INFO, PAGING_INFO };
